import React from "react";
import { Card } from "../ui/card";
import { Label } from "../ui/label";
import { Input } from "../ui/input";
import FormSelect from "./FormSelect";

const normalize = (v) => String(v ?? "").trim();

const DynamicFormSection = ({
  title,
  fields = [],
  formData,
  setFormData,
  masters = {}
}) => {

  const updateField = (name) => (value) => {
    setFormData(prev => ({
      ...prev,
      [name]: normalize(value)
    }));
  };

  const getList = (key) => {
    return Array.isArray(masters[key]) ? masters[key] : [];
  };

  const renderField = (field) => {

    // ================= INPUT =================
    if (field.type === "input") {
      return (
        <div key={field.name}>
          <Label>{field.label}</Label>
          <Input
            value={normalize(formData[field.name])}
            onChange={(e) => updateField(field.name)(e.target.value)}
            placeholder={field.placeholder || ""}
          />
        </div>
      );
    }

    // ================= SELECT =================
    if (field.type === "select") {
      const list = getList(field.master);

      return (
        <div key={field.name}>
          <Label>{field.label}</Label>

          <FormSelect
            list={list}
            value={normalize(formData[field.name])}
            onChange={updateField(field.name)}
            placeholder={field.placeholder || "Select"}
            disabled={!list.length}
          />
        </div>
      );
    }

    // ================= GROUP =================
    if (field.type === "group") {
      return (
        <div key={field.label}>
          <Label>{field.label}</Label>

          <div className="grid grid-cols-2 gap-2 mt-1">
            {field.fields.map((sub) => {
              const list = getList(sub.master);

              return (
                <FormSelect
                  key={sub.name}
                  list={list}
                  value={normalize(formData[sub.name])}
                  onChange={updateField(sub.name)}
                  placeholder={sub.placeholder}
                  disabled={!list.length}
                />
              );
            })}
          </div>
        </div>
      );
    }

    return null;
  };

  return (
    <Card className="p-6">
      <h2 className="text-xl font-semibold mb-4">{title}</h2>

      <div className="grid grid-cols-1 md:grid-cols-2 gap-4">
        {fields.map(renderField)}
      </div>
    </Card>
  );
};

export default DynamicFormSection;